import { UpdateMarkConversationAsReadActionPayload, UpdateNotificationsActionPayload, UpdateUnreadNotificationItemsCountActionPayload } from './rootReducerTypes';

export type NotificationActionTypes =
    UpdateNotificationListAction |
    UpdateUnreadNotificationItemsCountAction |
    UpdateMarkConversationAsReadAction;

export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export interface UpdateNotificationListAction {
    type: typeof UPDATE_NOTIFICATIONS;
    updateNotificationsActionPayload: UpdateNotificationsActionPayload;
}

export const UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT = "UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT";
export interface UpdateUnreadNotificationItemsCountAction {
    type: typeof UPDATE_UNREAD_NOTIFICATION_ITEMS_COUNT,
    updateUnreadNotificationItemsCountActionPayload: UpdateUnreadNotificationItemsCountActionPayload
}

export const UPDATE_MARK_CONVERSATION_AS_READ = "UPDATE_MARK_CONVERSATION_AS_READ";
export interface UpdateMarkConversationAsReadAction {
    type: typeof UPDATE_MARK_CONVERSATION_AS_READ,
    updateMarkConversationAsReadActionPayload: UpdateMarkConversationAsReadActionPayload
}